// BarChartPPAandNV.jsx
import React from 'react';
import BarChartGeneric from './BarChartGeneric';
// import transformDataPPAandNV from './transformDataPPAandNV';
import { ALL_METRICS } from '../../constants/constantsAnalytic';

const BarChartPPAandNV = (props) => {
  const t = (key, fallback) => {
    const value = typeof props.translate === 'function' ? props.translate(key) : key;
    return value && value !== key ? value : fallback;
  };
     // Define las claves de las métricas que quieres mostrar
  const alarmGraph = ['perdidos_count', 'visitas_count'];
  // const alarmGraph2 = ['perdidos_cout', 'visitas_cout'];

  const toggleLabels = ALL_METRICS
    .filter(metric => alarmGraph.includes(metric.key))
    .map((metric, i) => ({
      field: metric.key,
      label: metric.key === 'perdidos_count'
        ? `${t('pellets_lost', 'Pellets perdidos')} ${t('accumulated', 'Acumulado')} [PPA]`
        : t('visits', 'Visitas'),
      activeColor: metric.color,
      inactiveColor: metric.inactiveColor,
      axis: i === 0 ? 'left' : 'right',
    }));

  const handleContextMenu = (e, field) => {
    e.preventDefault();
    e.stopPropagation();
    if (field !== 'alarms_by_ton' && field !== 'alarms_by_visits') {
      return; // No hacer nada si no coincide
    }

    if (field === 'alarms_by_ton') {
      // Cambia a Alarmas / Visitas + Alarmas
      props.setAlarmGraph(['alarms_count','alarms_by_visits']);
    } else if (field === 'alarms_by_visits') {
      // Regresa a Alarmas / Ton + Alarmas
      props.setAlarmGraph(['alarms_count','alarms_by_ton']);
    }
  };

  return (
    <BarChartGeneric 
      {...props}
      toggleLabels={toggleLabels}
      handleContextMenu={handleContextMenu}
      alarmGraph={alarmGraph}
      // alarmGraph2={alarmGraph2}

    />
  );
};

export default BarChartPPAandNV;
